import "core-js/modules/es6.function.name";
import { registerMicroApps, start } from 'qiankun';
import { microApps } from "./micro";
export default function () {
  registerMicroApps(microApps, {
    beforeLoad: function beforeLoad(app) {
      return console.log('beforeLoad ===> ', app.name);
    },
    beforeMount: function beforeMount(app) {
      return console.log('beforeMount', app.name);
    },
    afterMount: function afterMount(app) {
      return console.log('afterMount ===> ', app.name);
    },
    beforeUnmount: function beforeUnmount(app) {
      return console.log('beforeUnmount ===> ', app.name);
    },
    afterUnmount: function afterUnmount(app) {
      return console.log('afterUnmount ===> ', app.name);
    }
  }); // 启动微服务

  start({
    prefetch: false
  });
}